import { render, staticRenderFns } from "./MyCanvas.vue?vue&type=template&id=2c8e8f08&scoped=true"
import script from "./MyCanvas.vue?vue&type=script&lang=js"
export * from "./MyCanvas.vue?vue&type=script&lang=js"
import style0 from "./MyCanvas.vue?vue&type=style&index=0&id=2c8e8f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e8f08",
  null
  
)

export default component.exports